import { HttpClientModule } from '@angular/common/http';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { OAuthModule, OAuthModuleConfig } from 'angular-oauth2-oidc';
import { AuthGuardWithForcedLogin } from './auth-guard-with-forced-login.service';
import { RoleGuard } from './role-guard.service';
import { authModuleConfig } from './auth-module-config';
import { AuthService } from './auth.service';

@NgModule({
  imports: [HttpClientModule, OAuthModule.forRoot()],
  providers: [AuthService, RoleGuard, AuthGuardWithForcedLogin],
})
export class AuthModule {
  constructor(@Optional() @SkipSelf() parentModule: AuthModule) {
    if (parentModule) {
      throw new Error('AuthModule is already loaded.');
    }
  }

  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [{ provide: OAuthModuleConfig, useValue: authModuleConfig }],
    };
  }
}
